export default __webpack_public_path__ + "static/media/success.6cd84c3b73483441991d3cf1273a5a82.svg";